import React from "react";
import {
	SimpleGrid,
	Box,
	Text,
	Flex,
	WrapItem,
	Avatar,
	Input,
	IconButton,
	InputRightElement,
	Stack,
	Button,
	Icon,
	Grid,
	GridItem,
} from "@chakra-ui/react";
import { AiOutlineSend } from "react-icons/ai";
import { InputGroup } from "@chakra-ui/react/dist/chakra-ui-react.cjs";

function Support() {
	const messages = [
		{ user: "support", message: "Hello, how can we help you?" },
		{
			user: "user",
			message: "Hello, I would like to know more about upgrading my plan",
		},
	];
	return (
		<Grid
			m={5}
			templateColumns={{ base: "1fr", md: "2fr 1fr" }}
			gap={10}
			pt={{ base: "120px", md: "75px" }}
		>
			<Box>
				<Text fontSize="24px" fontWeight="bold" bg="#33333B" py="16px" px="8px">
					Chat with the Docs
				</Text>
				<Flex
					direction="column"
					h="40vh"
					justify="end"
					border="1px"
					borderColor="#2F2F36"
				>
					{messages.map((message, index) => (
						<Flex
							direction="row"
							key={index}
							alignSelf={message.user === "support" ? "flex-start" : "flex-end"}
						>
							{message.user === "support" && (
								<WrapItem>
									<Avatar
										name="Dan Abrahmov"
										src="https://bit.ly/dan-abramov"
									/>
								</WrapItem>
							)}

							<Box
								bg={message.user === "support" ? "#33333B" : "#71C9EC"}
								color={message.user === "support" ? "white" : "black"}
								borderRadius="12px"
								borderTopLeftRadius={
									message.user === "support" ? "0px" : "12px"
								}
								borderTopRightRadius={
									message.user === "support" ? "12px" : "0px"
								}
								w="fit-content"
								p="16px"
								m="8px"
							>
								{message.message}
							</Box>
							{message.user === "user" && (
								<WrapItem>
									<Avatar
										name="Dan Abrahmov"
										src="https://bit.ly/dan-abramov"
									/>
								</WrapItem>
							)}
						</Flex>
					))}
				</Flex>
				<Box bg="#33333B" p="24px">
					<InputGroup>
						<Input
							placeholder="Type a message here..."
							bg="#3D3D44"
							p="16px"
							borderRadius="14px"
							h="72px"
						/>
						<InputRightElement
							h="72px"
							mr="8px"
							children={
								<IconButton
									aria-label="Send"
									icon={
										<AiOutlineSend boxSize={{ base: "48px", md: "64px" }} />
									}
								/>
							}
						/>
					</InputGroup>
				</Box>
			</Box>
			<Flex direction="column" gap={5}>
				{[1, 2].map((item, index) => (
					<Stack
						key={index}
						direction="column"
						py="34px"
						px="30px"
						borderRadius="16px"
						bg="#33333B"
					>
						<Text fontSize="24px" fontWeight="bold">
							Read the Docs
						</Text>
						<Text fontSize="16px">
							{" "}
							Lorem ipsum dolor sit, amet consectetur adipisicing elit. Repellat
							nulla quae praesentium assumenda aspernatur iste sunt optio?
							Reprehenderit, velit voluptate?
						</Text>
						<Button
							w="100%"
							bg="#16BF5D"
							py="12px"
							px="24px"
							borderRadius="16px"
							mb={3}
						>
							Read the Docs
						</Button>
					</Stack>
				))}
			</Flex>
		</Grid>
	);
}

export default Support;
